import attack from '../../request/request'
import { UCENTER } from '../requers_variable'

export default {
  /**
   * 校验6位验证码格式
   *
   * @param {any} number
   * @returns
   */
  verity_six_code(number) {
    let reg = /^\d{6}$/,
      state = {type: 0, msg: ''};
    if (number == '') {
      state.type = 0;
      state.msg = '验证码不能为空';
      return state
    } else if (!reg.test(number)) {
      state.type = 1;
      state.msg = '验证码格式错误';
      return state
    } else {
      state.type = 2;
      state.msg = '验证码格式正确';
      return state
    }
  },
  /**
   * 校验验证码格式
   *
   * @param {any} number
   * @returns
   */
  verity_code(number) {
    let reg = /^\d{4}$/,
        state = {type: 0, msg: ''};
    if (number == '') {
      state.type = 0;
      state.msg = '验证码不能为空';
      return state
    } else if (!reg.test(number)) {
      state.type = 1;
      state.msg = '验证码格式错误';
      return state
    } else {
      state.type = 2;
      state.msg = '验证码格式正确';
      return state
    }
  },
  /**
   * 校验图片验证码是否正确
   *
   * @param {any} number
   * @returns
   */
  correct_imgcode(number) {
    return new Promise(function (resolve, reject) {
      attack({
        type: 'post',
        url: `${UCENTER}/captcha/verity`,
        data: {
          captcha: number
        },
        success(rep) {
          resolve(true)
        },
        error(rep) {
          resolve(false)
        }
      })
    })
  },
  /**
   * 校验短信验证码
   *
   * @param {any} number
   * @returns
   */
  correct_smscode(number) {
    return new Promise(function (resolve, reject) {
      attack({
        type: 'post',
        url: `${UCENTER}/account/sms/verity`,
        data: {
          smsCode: number
        },
        success(rep) {
          resolve(true)
        },
        error(rep) {
          resolve(false)
        }
      })
    })
  },
  /**
   * 切换图片验证码
   *
   * @returns
   */
  verityimg_change() {
    let randomNum = JSON.stringify(Math.random()).substring(3, 21)
    return `/api/ucenter/captcha/get?width=120&height=40&num=${randomNum}`
  },
  /**
   * 获取短信验证码
   *
   * @param {any} params
   * @returns
   */
  get_smscode(params) {
    return new Promise(function (resolve, reject) {
      attack({
        type: 'post',
        url: `${UCENTER}/account/sms/code`,
        data: params,
        success(rep) {
          resolve(true)
        },
        error(rep) {
          resolve(false)
        }
      })
    })
  },
  /**
   * 获取重置时短信验证码
   *
   * @param {any} params
   * @returns
   */
  get_rebackpasswdsmscode(params) {
    return new Promise(function (resolve, reject) {
      attack({
        type: 'post',
        url: `${UCENTER}/account/sms/code/rebackpasswd`,
        data: params,
        success(rep) {
          resolve(true)
        },
        error(rep) {
          resolve(false)
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/data/ucenter/captcha.js